import React, { useState } from 'react';
import { Mail, ArrowLeft, CheckCircle, Loader2 } from 'lucide-react';
import { authAPI } from '../services/api';
import { useToast } from '../hooks/use-toast';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword(email.trim().toLowerCase());
      setSent(true);
    } catch (error) {
      toast({ title: 'Erreur', description: "Impossible d'envoyer l'email. Réessayez.", variant: 'destructive' });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-500 to-blue-600 shadow-lg shadow-cyan-500/25 mb-4">
            <Mail className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Mot de passe oublié</h1>
          <p className="text-sm text-slate-400 mt-2">
            Entrez votre email, nous vous enverrons un lien de réinitialisation
          </p>
        </div>

        {sent ? (
          <div className="bg-white/5 border border-white/10 rounded-xl p-6 text-center" data-testid="forgot-password-success">
            <CheckCircle className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
            <p className="text-white text-sm font-medium mb-2">Email envoyé !</p>
            <p className="text-slate-400 text-xs leading-relaxed">
              Si un compte existe avec <strong className="text-slate-300">{email}</strong>, vous recevrez un lien de réinitialisation valable 1 heure. Vérifiez aussi vos spams.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              required
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              inputMode="email"
              className="w-full px-4 py-3.5 bg-white/5 border border-white/10 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/50 transition-all text-sm"
              data-testid="forgot-password-email"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold rounded-xl shadow-lg shadow-cyan-500/25 active:scale-[0.98] transition-all disabled:opacity-60 flex items-center justify-center gap-2 text-sm"
              data-testid="forgot-password-submit"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Envoyer le lien'}
            </button>
          </form>
        )}

        <div className="text-center mt-6">
          <a href="/login" className="inline-flex items-center gap-2 text-xs text-slate-400 hover:text-slate-200 transition-colors" data-testid="back-to-login-link">
            <ArrowLeft className="w-3 h-3" />
            Retour à la connexion
          </a>
        </div>
      </div>
    </div>
  );
}
